import { useQuery } from "@tanstack/react-query";
import { getChurchById } from "@/api/churches";

export function useChurchTimezone(churchId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: ["church", churchId],
    queryFn: () => getChurchById(churchId!),
    enabled: !!churchId && enabled,
    staleTime: 60_000,
  }).data?.timezone;
}
